import { render, staticRenderFns } from "./onboardClinic.vue?vue&type=template&id=50badd6c&"
import script from "./onboardClinic.vue?vue&type=script&lang=js&"
export * from "./onboardClinic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports